import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import StockData from "./StocksData/stockData";
import LoginPage from "./LoginPage/LoginPage";
import StockRecommend from "./StockRecommend/StockRecommend";
import StockWishlist from "./StockWishlist/StockWishlist";
import Options from "./components/Options/Options";
import ServiceStatusFooter from "./components/ServiceStatusFooter";
import { useState } from "react";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('authToken'));

  // auth state is managed by Login/Navigation; no local logout helper needed here

  return (
    <div className="App min-h-screen">
      <Router>
        <div className="flex min-h-screen flex-col">
          <main className="flex-1">
            <Routes>
              <Route
                path="/login"
                element={
                  isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <LoginPage onLogin={setIsAuthenticated} />
                  )
                }
              />
              <Route
                path="/dashboard"
                element={isAuthenticated ? <StockData /> : <Navigate to="/login" />}
              />
              <Route
                path="/recommendations"
                element={
                  isAuthenticated ? <StockRecommend /> : <Navigate to="/login" />
                }
              />
              <Route
                path="/wishlist"
                element={
                  isAuthenticated ? <StockWishlist /> : <Navigate to="/login" />
                }
              />
              <Route
                path="/options"
                element={
                  isAuthenticated ? <Options /> : <Navigate to="/login" />
                }
              />
              <Route
                path="/"
                element={
                  <Navigate to={isAuthenticated ? "/dashboard" : "/login"} />
                }
              />
            </Routes>
          </main>
          <ServiceStatusFooter />
        </div>
      </Router>
    </div>
  );
}

export default App;
